import { useGoogleLogin } from '@react-oauth/google';
import { notify } from 'components/ToastNotification/ToastNotification';
import { IconManager } from 'components/_universal/IconManager/IconManager';
import { useHistory } from 'react-router-dom';
import LocalStorageManager from 'services/LocalStorageManager/LocalStorageManager';
import paths from 'shared/paths';
import { useRegisterMutation } from 'src/graphql/generated';
import { ToastTypes } from 'types/CommonTypes';
import { useForm } from 'react-hook-form';
import LogoImg from 'assets/images/logo_login.png';
import WaveBackground from 'assets/images/wave_background.png';
import {
    AnotherText,
    ExternalLinkWrapper,
    FormWrapper,
    LinkWrapper,
    Logo,
    PageBox,
    PageWrapper,
    SecondaryText,
    StyledButton,
    StyledGoogleButton,
    StyledInput,
    StyledLink,
    Text,
    WaveWrapper,
} from '../SharedLogin.styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSignUp } from '../validations';

interface SignUpFormInputs {
    email: string;
    name: string;
    password: string;
}

export const SignUpPage = () => {
    const history = useHistory();
    const {
        control,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
    } = useForm<SignUpFormInputs>({
        resolver: yupResolver(validationSignUp),
    });

    const [register, { loading }] = useRegisterMutation();

    const onSubmit = async (data: SignUpFormInputs) => {
        try {
            const response = await register({
                variables: {
                    data: {
                        email: data.email,
                        name: data.name,
                        password: data.password,
                    },
                },
            });

            if (response.data?.register) {
                notify('Rejestracja zakończona pomyślnie')[
                    ToastTypes.SUCCESS
                ]();
                reset();
                history.push(paths.login);
            }
        } catch (err) {
            console.error(err);
            notify('Coś poszło nie tak, spróbuj ponownie')[ToastTypes.ERROR]();
        }
    };

    return (
        <PageWrapper>
            <StyledLink to={paths.login}>
                <Logo src={LogoImg} />
            </StyledLink>
            <WaveWrapper src={WaveBackground} />
            <PageBox>
                <FormWrapper onSubmit={handleSubmit(onSubmit)}>
                    <StyledInput
                        control={control}
                        errors={errors.name}
                        iconType={'ProfileIcon'}
                        marginBottom={30}
                        name={'name'}
                        placeholder={'Imię i Nazwisko'}
                        type={'text'}
                    />
                    <StyledInput
                        control={control}
                        errors={errors.email}
                        iconType={'Email'}
                        marginBottom={30}
                        name={'email'}
                        placeholder={'Email'}
                        type={'text'}
                    />
                    <StyledInput
                        control={control}
                        errors={errors.password}
                        iconType={'Password'}
                        marginBottom={40}
                        name={'password'}
                        placeholder={'Hasło'}
                        type={'password'}
                    />

                    <StyledButton buttonType="black" type="submit">
                        {isSubmitting || loading
                            ? 'Rejestrowanie...'
                            : 'ZAREJESTRUJ SIĘ'}
                    </StyledButton>

                    <Text>Logując się akceptujesz</Text>
                    <SecondaryText>
                        <ExternalLinkWrapper
                            href={paths.service_rules}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Zasady usługi
                        </ExternalLinkWrapper>
                        i
                        <ExternalLinkWrapper
                            href={paths.privacy_policy}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Politykę prywatności
                        </ExternalLinkWrapper>
                    </SecondaryText>
                    <Text>
                        Masz już konto?
                        <LinkWrapper to={paths.login}>Zaloguj się</LinkWrapper>
                    </Text>
                </FormWrapper>
            </PageBox>
        </PageWrapper>
    );
};
